import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.y4l_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.y4l_1;
        tmp.z4l_1 = Array(size);
        this.a4m_1 = 0;
      }
      b4m(instance) {
      }
      c4m(instance) {
        return instance;
      }
      d4m(instance) {
      }
      e4m() {
        if (this.a4m_1 === 0)
          return this.x4l();
        this.a4m_1 = this.a4m_1 - 1 | 0;
        var idx = this.a4m_1;
        var tmp = this.z4l_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.z4l_1[idx] = null;
        return this.c4m(instance);
      }
      f4m(instance) {
        this.d4m(instance);
        if (this.a4m_1 === this.y4l_1) {
          this.b4m(instance);
        } else {
          var _unary__edvuaz = this.a4m_1;
          this.a4m_1 = _unary__edvuaz + 1 | 0;
          this.z4l_1[_unary__edvuaz] = instance;
        }
      }
      vz() {
        var inductionVariable = 0;
        var last = this.a4m_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.z4l_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.z4l_1[i] = null;
            this.b4m(instance);
          }
           while (inductionVariable < last);
        this.a4m_1 = 0;
      }
    }
    protoOf($).q6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
